import { useEffect, useState } from 'react';
import { ordersApi, type Order } from '../../api/orders';

export function AllocationDashboardPage() {
  const [orders, setOrders] = useState<Order[]>([]);

  useEffect(() => {
    void ordersApi.list({ status: 'validated' }).then(setOrders).catch(() => {
      void ordersApi.list().then(setOrders);
    });
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Allocation Dashboard</h1>
      <p className="mt-1 text-sm text-slate-600">Orders awaiting inventory allocation.</p>
      <ul className="mt-6 space-y-3">
        {orders.filter((o) => o.allocation_status === 'pending' || o.allocation_status === 'partial').map((o) => (
          <li key={o.id} className="flex items-center justify-between rounded border bg-white p-4 text-sm">
            <span>{o.order_number} — {o.source}</span>
            <button type="button" className="text-blue-600 hover:underline" onClick={() => void ordersApi.allocate(o.id)}>Allocate</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
